import type { Movie } from '@/types/media';
import SectionHeading from '@/components/base/SectionHeading';
import MovieCard from '@/components/base/MovieCard';

interface LatestMoviesProps {
  movies: Movie[];
}

export default function LatestMovies({ movies }: LatestMoviesProps) {
  const latest = [...movies].sort((a, b) => b.year - a.year || b.heat - a.heat).slice(0, 12);

  return (
    <section className="max-w-8xl mx-auto px-4 md:px-8 pb-12 md:pb-16">
      <SectionHeading
        eyebrow="NEW RELEASES"
        title="最新影视资源推荐"
        desc="汇集近期上映的电影与热播剧集，按更新时间为你精选呈现。"
        moreTo="/category?type=movie"
        moreLabel="全部影视"
      />
      {latest.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 text-center bg-background-100 rounded-lg border border-background-200">
          <i className="ri-inbox-2-line text-4xl text-foreground-300"></i>
          <p className="mt-4 text-sm text-foreground-500">暂无最新影视资源</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {latest.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </section>
  );
}